import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user

  useEffect(() => {
    if (!localStorage.getItem("nk_token")) {
      setUser(false);
      return;
    }
    api.me().then(setUser).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    try {
      const u = await api.login(email, password);
      setToken(u.token);
      setUser(u);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    await api.logout().catch(() => {});
    setToken(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
